module.exports = __webpack_public_path__ + "img/home_icon.4c0a655c.png";